import { defineMessages } from 'react-intl';

export default defineMessages({
  removeCarrierServiceArialLabelText: {
    description: 'Aria label for the remove carrier service button',
    defaultMessage: 'Remove',
    id: 'tYaPyi',
  },
  tagBankInternationalServices: {
    description: 'Header text for international services in the carrier service group',
    defaultMessage: 'International shipments are compared using these services:',
    id: '7CUc/g',
  },
});
